export const BloodGridActions = {
    BLOOD_CLASS_CHANGED: "BLOOD_CLASS_CHANGED",
    BLOOD_FILTER_DEFAULT: "BLOOD_FILTER_DEFAULT",
    BLOOD_ANNO_STOP_MOVE: "BLOOD_ANNO_STOP_MOVE",
    BLOOD_ANNO_UPDATE_SUMMARY: "BLOOD_ANNO_UPDATE_SUMMARY",
    UPDATE_PAGE: "UPDATE_PAGE",
} 